import { useMemo } from 'preact/hooks';
import { updateUrlParameter } from '../helpers/utils';

/**
 * Prepare dynamic footer information
 *
 * @return {{data: Object|null, error: boolean}}
 */
const useFooterData = (campaignData, storefrontConfig) => {
    return useMemo(() => {
        try {
            const footerData = storefrontConfig?.data;
            const campaignUuid = campaignData?.data?.campaign?.uuid;
            const appsLinksIndex = footerData?.menus?.footer?.findIndex(
                (element) => element.kind === 'images' && element.items[0] && element.items[0].text.indexOf('ios') >= 0
            );

            //add campaing id to apps link
            if (appsLinksIndex >= 0) {
                footerData.menus.footer[appsLinksIndex].items.forEach((element) => {
                    element.href = updateUrlParameter(element.href, 'cm_campaign', campaignUuid);
                });
            }

            return { error: false, data: footerData };
        } catch (error: any) {
            console.error(`Footer data error: ${error.message}`);
            return { error: true, data: null };
        }
    }, [campaignData, storefrontConfig]);
};

export default useFooterData;
